import React from "react";
import UserDashboard from "../UserDashboard/UserDashboard";

// Archiwum tranzytu - ten sam widok co dashboard, z danymi zakończonego tranzytu.
const TranzytArchive = () => <UserDashboard view="tranzytArchiwum" />;

export default TranzytArchive;
